import { ConcreteEncodable } from "./ConcreteEncodable";

import { InflightCheckStateEventImplEncoder } from "../../encoder/InflightCheckStateEventImplEncoder";

import * as CubiqTS from "../../index";
import { InflightCheckStateEvent } from "../InflightCheckStateEvent";

export class InflightCheckStateEventImpl
  extends ConcreteEncodable
  implements InflightCheckStateEvent
{
  public static enType: string = "com.bcdfx.model.event.InflightCheckStateEventImpl";

  /*FID=1*/
  public inflightInclusionState: CubiqTS.InflightInclusionState;
  /*FID=2*/
  public orderIds: Array<CubiqTS.Long> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = InflightCheckStateEventImplEncoder.Instance;
    this.setEncodableType(InflightCheckStateEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "InflightCheckStateEventImpl[" +
      "inflightInclusionState=" +
      this.inflightInclusionState +
      "orderIds=" +
      this.orderIds +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
